import React from "react";
import Trash from "@/assets/icons/TrashV2.svg";
import Link from "@/assets/icons/Link.svg"; // Reuse the same link icon
import { motion } from "motion/react";
import { showCustomToast } from "@/components/CustomToast";

type action = "delete" | "copy";

const options: any = [
  // { icon: Link, text: "Copy recording link", action: "copy" },
  { icon: Trash, text: "Delete recording link", action: "delete" },
];

const RecordingLinkOptions = ({
  setShowConfirmDelete,
  setShowOptions,
  recordingLinkToken,
}: {
  setShowConfirmDelete: (show: boolean) => void;
  setShowOptions: (show: boolean) => void;
  recordingLinkToken: string;
}) => {
  const handleOptionClick = (action: action) => {
    switch (action) {
      // case "copy":
      // const linkUrl = `${window.location.origin}/record/${recordingLinkToken}`;
      // navigator.clipboard.writeText(linkUrl);
      // showCustomToast("Recording link copied to clipboard", "check");
      //   break;
      case "delete":
        setShowConfirmDelete(true);
        break;
    }
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="absolute w-[200px] options_shadow z-[50] top-[calc(100%+1px)] right-0 bg-black rounded-[17.6px] p-[1px]"
      >
        <div className="border-[0.5px] flex flex-col gap-[2px] border-white/[0.35] rounded-[17px] p-[2.5px]">
          {options.map((option: any, i: number) => {
            return (
              <button
                key={i}
                className="px-[10px] hover:bg-white/[0.15] rounded-[14px] transition-all py-[7px] text-[14px] onest-md leading-[17.85px] flex gap-[6px] items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleOptionClick(option.action);
                  setShowOptions(false);
                }}
              >
                <img src={option.icon} alt={option.text} />
                {option.text}
              </button>
            );
          })}
        </div>
      </motion.div>
    </>
  );
};

export default RecordingLinkOptions;
